import type { RouteParamsRequest } from '@pba/react-utils';
import { type ApiClientResponse, apiClient, routes } from 'common/services';
import type { CommunityInvitationTokenDataObject } from 'models/service';

type GetCommunityInvitationTokenRouteParams = {
  id: string;
};

export const getInvitationToken = async ({
  routeParams: { id },
}: RouteParamsRequest<GetCommunityInvitationTokenRouteParams>) =>
  apiClient.post<CommunityInvitationTokenDataObject, ApiClientResponse<CommunityInvitationTokenDataObject>>(
    routes.community.invitationToken(id),
  );
